import { Trans, useLingui } from '@lingui/react'
import { bool, node, string } from 'prop-types'
import { useDispatch } from 'react-redux'

import './OnlineDoctorServiceModal.scss'
import { DOCUMENT_TYPE } from 'shared/consts/checkout'
import { deleteCartItemAction } from 'shared/store/ducks/cart'
import { deleteCartOffersAction } from 'shared/store/ducks/cart/actions'
import { hideModalAction } from 'shared/store/ducks/events'
import Button from 'views/components/atoms/Button'
import Modal from 'views/components/molecules/Modal'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import { i18nType } from 'views/utils/propTypes'

const OnlineDoctorServiceModal = ({ modalId, size, title, open, offerID }) => {
  const dispatch = useDispatch()
  const { i18n } = useLingui()

  return (
    <Modal
      {...{
        id: modalId,
        size,
        title: title || <Trans id="Modal.deleteZavaModal.title" />,
        open,
      }}
      isClientSideControlled
    >
      <ul className="a-list-reset u-margin--bottom">
        <li className="l-flex u-margin-large--bottom">
          <TransWithHtml
            text={i18n._('Modal.deleteZavaModal.bodyText')}
            element="p"
          />
        </li>
      </ul>
      <ul className="a-list-reset l-flex l-flex--distribute-space@medium l-flex--vertical-stretch@small-tiny l-flex__column_reverse@small-tiny u-margin-large--top@small-tiny">
        <li className="l-flex__full-width u-margin--right@medium">
          <Button
            data-a11y-dialog-hide
            name="DeleteODSModal-cancel"
            isClientsideControlled
            type="button"
          >
            <Trans id="Modal.deleteZavaModal.cancelBtn.text" />
          </Button>
        </li>
        <li className="l-flex__full-width u-margin-small--bottom@small-tiny">
          <Button
            style="buttonGhost"
            type="submit"
            name="DeletePrescriptionModal-submit"
            id="btnSubmitDeletePrescriptionModal"
            onClick={() => {
              dispatch(
                deleteCartOffersAction([
                  { offerId: offerID, pType: DOCUMENT_TYPE.ODS_SECTION },
                ])
              )
              dispatch(deleteCartItemAction())
              dispatch(hideModalAction(modalId))
            }}
          >
            <Trans id="Modal.deleteZavaModal.submitBtn.text" />
          </Button>
        </li>
      </ul>
    </Modal>
  )
}

OnlineDoctorServiceModal.propTypes = {
  modalId: string.isRequired,
  size: string.isRequired,
  title: node,
  open: bool,
  offerID: string.isRequired,
  i18n: i18nType.isRequired,
}
OnlineDoctorServiceModal.defaultProps = {
  title: null,
  open: false,
}

export default OnlineDoctorServiceModal
